var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('TheHeader',{attrs:{"logoColor":"#ffffff"}}),_c('TheHero'),_c('TheCompatibles'),_c('TheWhy'),_c('TheFeatures'),_c('TheTechnology'),_c('TheSolution'),_c('TheCaseStudies'),_c('SeeInAction'),_c('TheFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }